/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class InputBehaviorComponent extends React.Component {
    render() {
        let constants = this.props.app.config.constants,
            FirstPullOptions = null,
            action = '',
            postFlag = (this.props.input && this.props.input.postFlag) ? this.props.input.postFlag : 0,
            firstPullOptions = [],
            behaviorOptions = [
                {value: constants.POST_NOW, label: 'Share Immediately'},
                {value: constants.POST_QUEUE, label: 'Add to your queue'}
            ];

        if (parseInt(this.props.input.postFlag) === constants.POST_NOW) {
            action = 'Post';
        } else {
            action = 'Queue';
        }

        firstPullOptions = [
            {value: constants.FIRSTPULL_SINGLE, label: action + ' the most recent item now'},
            {value: constants.FIRSTPULL_OFF, label: action + ' when a new item is published'},
            {value: constants.FIRSTPULL_ON, label: action + ' all items (up to max)'},
        ];

        if (this.props.showFirstPull) {
            FirstPullOptions = (
                <fieldset>
                    <legend>When should we make your first post?</legend>
                    <StyledSelect
                        options={firstPullOptions}
                        linkedField={this.props.statePath + ".firstPullFlag"}
                        value={this.props.input.firstPullFlag}
                        selectClass="large"
                        onChange={this.props.changeHandler}/>
                </fieldset>
            );
        }

        return (
            <div>
                <fieldset>
                    <legend>When should we post new items?</legend>
                    <StyledSelect
                        options={behaviorOptions}
                        linkedField={this.props.statePath + ".postFlag"}
                        value={postFlag}
                        selectClass="large"
                        onChange={this.props.changeHandler}/>
                </fieldset>
                {FirstPullOptions}
            </div>
        );
    }

};

InputBehaviorComponent.displayName = "InputBehaviorComponent";

InputBehaviorComponent.propTypes = {
    input: PropTypes.object,
    changeHandler: PropTypes.func,
    statePath: PropTypes.string,
    showFirstPull: PropTypes.bool
};

InputBehaviorComponent.defaultProps = {
    input: {},
    changeHandler: null,
    statePath: 'input',
    showFirstPull: true
};

export default ComponentWithContext(InputBehaviorComponent);
